import React, { useRef } from 'react';
import { galleryImages } from '../mockData';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import Autoplay from 'embla-carousel-autoplay';

const Gallery = () => {
  const plugin = useRef(
    Autoplay({ 
      delay: 4000, 
      stopOnInteraction: true,
      stopOnMouseEnter: true 
    })
  );

  return (
    <section id="gallery" className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-zinc-500 text-sm tracking-widest mb-4 uppercase">Visual Feast</p>
          <h2 className="text-5xl md:text-6xl font-light text-white mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Gallery</h2>
          <div className="w-16 h-px bg-zinc-700 mx-auto mb-6"></div>
          <p className="text-zinc-400 max-w-2xl mx-auto font-light">
            A glimpse into our world of fine dining
          </p>
        </div>

        {/* Gallery Carousel - Optimized for Performance */}
        <Carousel
          plugins={[plugin.current]}
          className="w-full"
          opts={{
            align: 'start',
            loop: true,
            skipSnaps: false,
            dragFree: false,
          }}
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {galleryImages.map((image, index) => (
              <CarouselItem key={index} className="pl-2 md:pl-4 basis-full sm:basis-1/2 lg:basis-1/3">
                <div className="group relative overflow-hidden h-80">
                  <img
                    src={image}
                    alt={`Gallery ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover will-change-transform"
                    style={{ transform: 'translateZ(0)' }}
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:block">
            <CarouselPrevious className="-left-12 bg-zinc-900 border-zinc-700 text-white hover:bg-zinc-800" />
            <CarouselNext className="-right-12 bg-zinc-900 border-zinc-700 text-white hover:bg-zinc-800" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};

export default Gallery;